import React from "react";
import { useIntl } from "gatsby-plugin-intl";
import useNewsList from "@hooks/useNewsList";
import Title from "@components/Title";
import Panel from "@components/Panel";
import ShareWidget from "@components/ShareWidget";
import useLocationNoPrefix from "@hooks/useLocationNoPrefix";
import btnBg from "@images/global/btn-bg-01.png";
import { navigate } from "gatsby-link";
import "@assets/css/newsTemplate.scss";
import useWindowSize from "@hooks/useWindowSize";
import { MOBILE_BREAK_POINT } from "@models";

const buttonStyle = {
  position: "relative",
  minWidth: "200px",
  minHeight: "50px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
};

const btnTextStyle = {
  color: "#919191",
  fontWeight: 700,
  zIndex: 99,
};

const switchOrder = (A, B, condition) => {
  if (condition === true)
    return (
      <>
        {B}
        {A}
      </>
    );
  return (
    <>
      {A}
      {B}
    </>
  );
};

export default function NewsPageTemplate({ pageContext }) {
  const { pathname } = useLocationNoPrefix();
  const { newsList } = useNewsList();
  const { locale, formatMessage } = useIntl();
  const { frontmatter, html } = pageContext;
  const { title, date, img } = frontmatter;
  const currIdx = newsList.findIndex(el => el.path === pathname);
  const { width } = useWindowSize();

  return (
    <>
      <section className="news-section">
        <Title page="news" locale={locale} />
        <Panel>
          <div style={{ textAlign: "center", marginBottom: "40px" }}>
            <Panel.Title>{title}</Panel.Title>
          </div>
          <Panel.Grid>
            {switchOrder(
              <div style={{ maxHeight: "320px", overflowY: "auto" }} className="news-content">
                <p style={{ marginBottom: "10px" }}>{new Date(date).toLocaleDateString()}</p>
                <div dangerouslySetInnerHTML={{ __html: html }} />
              </div>,
              <img
                src={`${process.env.GATSBY_PREFIX}${img}`}
                alt="news-cover"
                style={{ width: "100%" }}
              />,
              width < MOBILE_BREAK_POINT
            )}
          </Panel.Grid>
          <div style={{ display: "flex", marginTop: "30px", alignItems: "center" }}>
            <span style={{ marginRight: "20px" }}>{formatMessage({ id: "share-to" })}</span>
            <ShareWidget
              title={title}
              url={typeof window !== `undefined` ? window.location.href : null}
            />
          </div>
        </Panel>
        <div style={{ display: "flex", justifyContent: "center" }}>
          {currIdx > 0 && (
            <div
              style={buttonStyle}
              onClick={() => {
                navigate(newsList[currIdx - 1].path);
              }}>
              <span style={btnTextStyle}>{formatMessage({ id: "news-prev" })}</span>
              <img
                src={btnBg}
                style={{ width: "100%", position: "absolute" }}
                alt="button-background"
              />
            </div>
          )}
          {currIdx < newsList.length - 1 && (
            <div
              style={buttonStyle}
              onClick={() => {
                navigate(newsList[currIdx + 1].path);
              }}>
              <img
                src={btnBg}
                style={{ width: "100%", position: "absolute" }}
                alt="button-background"
              />
              <span style={btnTextStyle}>{formatMessage({ id: "news-next" })}</span>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
